// import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
// import { useEffect, useState } from "react";
// import {
//   collection,
//   doc,
//   getDoc,
//   getDocs,
//   query,
//   where,
// } from "firebase/firestore";
// import {
//   firebaseConstants,
//   getDb,
//   multiselectDropdownStyle,
// } from "../../util/Constants";
// import _ from "lodash";
// import Multiselect from "multiselect-react-dropdown";
// import DataTable from "react-data-table-component";
// import { useParams } from "react-router-dom";
// import numeral from "numeral";
// import classNames from "classnames";

// export default function OverallStrengths({ signedInUser }) {
//   const [showing, setShowing] = useState("all");
//   const [grades, setGrades] = useState([]);
//   const [stats, setStats] = useState({});
//   const [users, setUsers] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [showingData, setShowingData] = useState([]);
//   const [capability, setCapability] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [regions, setRegions] = useState([]);
//   const [capabilitiesData, setCapabilitiesData] = useState([]);
//   const [gradesData, setGradesData] = useState([]);
//   const [departmentsData, setDepartmentsData] = useState([]);
//   const [regionsData, setRegionsData] = useState([]);
//   const [projectType, setProjectType] = useState([]);
//   const [registrationFeilds, setRegistrationFeilds] = useState("");
//   const db = getDb();
//   const usersRef = collection(db, firebaseConstants.dbUsers);
//   const utilRef = collection(db, firebaseConstants.dbUtil);
//   const regionRef = collection(db, firebaseConstants.dbRegions);
//   const departmentRef = collection(db, firebaseConstants.dbDepartments);
//   const { eventId } = useParams();

//   useEffect(() => {
//     getEventData().then((data) => {
//       console.log(data);
//       setCapabilitiesData(data.capabilitiesData);
//       setProjectType(data.projectType);
//       setRegistrationFeilds(data.registrationFeilds);
//       setDepartmentsData(data.departments);
//       setRegionsData(data.regions);
//     });

//     getMetaData().then((data) => {
//       const stats = {};

//       // Object.keys(data.grades).map(gradeName => {
//       //     stats[gradeName] = {};
//       // });
//       // setStats(stats);
//       setGrades(_.orderBy(data.grades, ["order"], ["asc"]));
//       // setCapabilitiesData(data.capabilities);
//       if (data.grades) {
//         setGradesData(data?.grades.map((_grade) => _grade.name));
//       }
//     });
//     getUsersData().then((data) => {
//       setStats(data._stats);
//       setUsers(data._users);
//       setShowingData(data._users);
//       // setTableData(data.users);
//     });
//   }, []);

//   useEffect(() => {
//     if (users.length > 0 && capability) {
//       let data = [];
//       data = showingData
//         .map((user) => {
//           if (capability) {
//             // const _cap = _.camelCase(capability);
//             const _cap = capability;
//             user.capability = {
//               name: capability,
//               value: numeral(
//                ( user[_cap]?.achievedScore / user[_cap]?.totalScore)*100
//               ).format("0,0"),
//             };

//             let category = "";
//             for (const _grade of grades) {
//               if (
//                 _grade?.start - 1 < user?.capability.value &&
//                 _grade?.end + 1 > user?.capability.value
//               ) {
//                 category = _.startCase(_grade?.name);
//                 break;
//               }
//             }

//             user.category = category;
//           }

//           return user;
//         })
//         .filter((user) => {
//           let result = true;

//           if (capability) {
//             result = result && user.capability.name === capability;
//           }
//           // if (categories.length > 0) {
//           //     result = result && categories.includes(user.category);
//           // }
//           if (departments.length > 0) {
//             result = result && departments.includes(user.department);
//           }
//           if (regions.length > 0) {
//             result =
//               result &&
//               regions
//                 .map((e) => e.toLowerCase())
//                 .includes(user.region.toLowerCase());
//           }

//           return result;
//         });

//       setTableData(data);
//     } else {
//       setTableData([]);
//     }
//   }, [capability, categories, departments, regions, showingData]);

//   useEffect(() => {
//     if (users.length > 0) {
//       if (showing === "completed") {
//         const _data = users.filter((user) => user.completedOnce);
//         setShowingData(_data);
//       } else {
//         setShowingData(users);
//       }
//     }
//   }, [showing]);

//   // stats -> capability1 -> [{user: dicota@geniteam.pk, percentage: 200, levels: 2}]

//   const getUsersData = async () => {
//     const _stats = {},
//       _users = [];
//     const q = query(usersRef, where("eventId", "==", eventId));
//     const querySnapshot = await getDocs(q);
//     querySnapshot.docs.forEach((doc) => {
//       if (doc.id !== "analytics") {
//         const userData = doc.data();

//         const user = { id: doc.id };
//         // _users.push({id: doc.id, ...userData});
//         if (userData.capabilities) {
//           Object.keys(userData.capabilities).map((capabilityName) => {
//             const capability = userData.capabilities[capabilityName];
//             const userObject = {
//               user: doc.id,
//               percentage: 0,
//               levels: 0,
//               achievedScore: 0,
//               totalScore: 0,
//             };

//             // if (capability.status && capability.scores) {
//             if (capability.scores) {
//               if (!_stats[capabilityName]) {
//                 _stats[capabilityName] = [];
//               }

//               Object.keys(capability.scores).map((levelName) => {
//                 if (capability.scores[levelName].totalQuestions > 0) {
//                   userObject.percentage +=
//                     capability.scores[levelName].percentage;
//                     userObject.achievedScore +=
//                     capability.scores[levelName].achievedScore;
//                     userObject.totalScore +=
//                     capability.scores[levelName].totalScore;
//                   userObject.levels++;
//                 }
//               });
//               // console.log(userObject);
//               _stats[capabilityName].push(userObject);
//               user[capabilityName] = userObject;
//             }
//           });
//         }

//         _users.push({
//           id: doc.id,
//           ...user,
//           name: userData.name,
//           email: userData.email,
//           department: userData.department,
//           region: userData.region,
//           completedOnce: userData.completedOnce,
//         });
//       }
//     });
// console.log(_stats);
// console.log( _users ,"data from db");
//     return { _stats: _stats, _users: _users };
//   };

//   const getMetaData = async () => {
//     const docRef = doc(utilRef, "meta");
//     const docSnap = await getDoc(docRef);
//     if (docSnap.exists()) {
//       return docSnap.data();
//     }

//     return {};
//   };

//   const getEventData = async () => {
//     const docRef = doc(db, "Events", eventId);
//     const docSnap = await getDoc(docRef);
//     if (docSnap.exists()) {
//       const data = docSnap.data().selectedLevels.competencies.map((e) => {
//         return e.name;
//       });
//       return {
//         capabilitiesData: data,
//         projectType: docSnap.data().projectType,
//         registrationFeilds: docSnap.data().registrationFields,
//         departments: docSnap.data().departments,
//         regions: docSnap.data().region,
//       };
//     }
//   };
//   const checkProjectType = () => {
//     return projectType === "progress";
//   };
//   return (
//     <>
//       <Container fluid>
//         <Row>
//           {grades.map((grade) => (
//             <Col lg={3} md={6} className="mb-4">
//               <Card className="bg-secondary shadow">
//                 <CardHeader className="bg-white border-0">
//                   <p className="text-muted small mb-0">Users</p>
//                   <h2 className="mb-0">{_.startCase(grade.name)}</h2>
//                 </CardHeader>
//                 <CardBody>
//                   {Object.keys(stats).map((capabilityName) => (
//                     <div className="d-flex justify-content-between mb-0">
//                       <p className="text-muted mb-0">
//                         {_.startCase(capabilityName)}
//                       </p>
//                       <p className="text-primary font-weight-bold mb-0">
//                         {stats[capabilityName].filter((user) => {
//                           const percentage = user.percentage / user.levels;
//                           return (
//                             grade.start - 1 < percentage &&
//                             grade.end + 1 > percentage
//                           );
//                         }).length || "-"}
//                       </p>
//                     </div>
//                   ))}
//                 </CardBody>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//         <Row className="mb-4">
//           <Col>
//             <div className="d-flex justify-content-between align-items-center">
//               <h1 className="mb-0 custom-font letterSpacing">Filters</h1>
//               <div className="d-flex justify-content-start">
//                 <label
//                   htmlFor="site_state"
//                   className={classNames("fw-bold", {
//                     "text-muted": showing !== "all",
//                   })}
//                 >
//                   All Users
//                   {/*<span className="badge bg-primary small ms-2">discounted</span>*/}
//                 </label>
//                 <label className="switch mx-2">
//                   <input
//                     id="site_state"
//                     type="checkbox"
//                     onChange={({ target }) => {
//                       target.checked
//                         ? setShowing("completed")
//                         : setShowing("all");
//                     }}
//                   />
//                   <span className="switch-slider always-on round" />
//                 </label>
//                 {/*<div className="form-check form-switch" style={{paddingLeft: 0}}>*/}
//                 {/*    <input type="checkbox" className="form-check-input always-on-switch" id="site_state"*/}
//                 {/*           onChange={({target}) => {*/}
//                 {/*               target.checked ? setShowing('all') : setShowing('completed')*/}
//                 {/*           }}*/}
//                 {/*    />*/}
//                 {/*</div>*/}
//                 <label
//                   htmlFor="site_state"
//                   className={classNames("fw-bold", {
//                     "text-muted": showing !== "completed",
//                   })}
//                 >
//                   Only Completed
//                 </label>
//               </div>
//             </div>

//             <Row>
//               <Col>
//                 <Row className="filters-bg d-flex mb-4 ">
//                   <Col>
//                     <Multiselect
//                       className="form-control-alternative mb-1 filters-sub"
//                       isObject={false}
//                       showArrow={true}
//                       selectionLimit={1}
//                       placeholder="Competency"
//                       options={capabilitiesData.map((data) =>
//                         _.startCase(data)
//                       )}
//                       closeIcon="cancel"
//                       onSelect={(list, item) =>
//                         setCapability(
//                           capabilitiesData.find(
//                             (_cap) => item === _.startCase(_cap)
//                           )
//                         )
//                       }
//                       onRemove={(list, item) => setCapability(null)}
//                       style={multiselectDropdownStyle}
//                     />
//                     <div className="d-flex justify-content-between align-items-center ">
//                       <p className="mb-0 small text-muted">Required</p>
//                       <p className="mb-0 small text-muted">Single Select</p>
//                     </div>
//                   </Col>
//                   {/* <Col lg={3}>
//                                         <Multiselect
//                                             className="form-control-alternative mb-1"
//                                             isObject={false}
//                                             showArrow={true}
//                                             placeholder="Category"
//                                             options={gradesData.map(data => _.startCase(data))}
//                                             closeIcon="cancel"
//                                             onSelect={(list, item) => setCategories([...categories, item])}
//                                             onRemove={(list, item) => setCategories(categories.filter(i => i !== item))}
//                                             style={multiselectDropdownStyle}
//                                         />
//                                         <p className="mb-0 small text-muted float-right">Multi Select</p>
//                                     </Col> */}
//                   {checkProjectType() &&
//                     registrationFeilds.includes("department") && (
//                       <Col>
//                         <Multiselect
//                           className="form-control-alternative mb-1 filters-sub"
//                           isObject={false}
//                           showArrow={true}
//                           placeholder="Department"
//                           options={departmentsData}
//                           closeIcon="cancel"
//                           onSelect={(list, item) =>
//                             setDepartments([...departments, item])
//                           }
//                           onRemove={(list, item) =>
//                             setDepartments(
//                               departments.filter((i) => i !== item)
//                             )
//                           }
//                           style={multiselectDropdownStyle}
//                         />
//                         <p className="mb-0 small text-muted float-right">
//                           Multi Select
//                         </p>
//                       </Col>
//                     )}
//                   {checkProjectType() &&
//                     registrationFeilds.includes("region") && (
//                       <Col>
//                         <Multiselect
//                           className="form-control-alternative mb-1 filters-sub"
//                           isObject={false}
//                           showArrow={true}
//                           placeholder="Region"
//                           options={regionsData}
//                           closeIcon="cancel"
//                           onSelect={(list, item) =>
//                             setRegions([...regions, item])
//                           }
//                           onRemove={(list, item) =>
//                             setRegions(regions.filter((i) => i !== item))
//                           }
//                           style={multiselectDropdownStyle}
//                         />
//                         <p className="mb-0 small text-muted float-right">
//                           Multi Select
//                         </p>
//                       </Col>
//                     )}
//                 </Row>
//               </Col>
//             </Row>
//           </Col>
//         </Row>
//         <Row className="mb-4">
//           <Col>
//             <Card className="shadow">
//               {/*<CardHeader className="border-0">*/}
//               {/*    <h2 className="mb-0">Leaderboard</h2>*/}
//               {/*</CardHeader>*/}
//               <DataTable
//                 columns={[
//                   {
//                     name: "Name",
//                     wrap: true,
//                     minWidth: "20%",
//                     selector: (row) => row.name,
//                   },
//                   {
//                     name: "Email",
//                     wrap: true,
//                     minWidth: "25%",
//                     selector: (row) => row.email,
//                   },
//                   {
//                     name: "Competency",
//                     wrap: true,
//                     minWidth: "20%",
//                     cell: (row) =>
//                       `${row.capability.name} - ${row.capability.value}%`,
//                   },
//                   // { name: 'Category', wrap: true, selector: row => row.category },
//                   registrationFeilds.includes("department") && {
//                     name: "Department",
//                     wrap: true,
//                     selector: (row) => row.department,
//                   },
//                   registrationFeilds.includes("region") && {
//                     name: "Region",
//                     wrap: true,
//                     selector: (row) => row.region,
//                   },
//                 ]}
//                 data={tableData}
//                 pagination
//                 responsive
//                 persistTableHead
//                 highlightOnHover
//               />
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </>
//   );
// }

import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {useEffect, useState} from "react";
import {
  collection,
  doc,
  getCountFromServer,
  getDoc,
  getDocs,
  limit,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import {firebaseConstants, getDb, multiselectDropdownStyle,} from "../../util/Constants";
import _ from "lodash";
import Multiselect from "multiselect-react-dropdown";
import DataTable from "react-data-table-component";
import {useParams} from "react-router-dom";
import numeral from "numeral";
import classNames from "classnames";

export default function OverallStrengths({ signedInUser }) {
  const [showing, setShowing] = useState("all");
  const [grades, setGrades] = useState([]);
  const [stats, setStats] = useState({});
  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showingData, setShowingData] = useState([]);
  const [capability, setCapability] = useState(null);
  const [categories, setCategories] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [regions, setRegions] = useState([]);
  const [capabilitiesData, setCapabilitiesData] = useState([]);
  const [gradesData, setGradesData] = useState([]);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [registrationFeilds, setRegistrationFeilds] = useState("");
  const db = getDb();
  const usersRef = collection(db, firebaseConstants.dbUsers);
  const utilRef = collection(db, firebaseConstants.dbUtil);
  const regionRef = collection(db, firebaseConstants.dbRegions);
  const departmentRef = collection(db, firebaseConstants.dbDepartments);
  const [lastVisible, setLastVisible] = useState(null);
  const { eventId } = useParams();

  const [activeUserCount, setActiveUserCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentUsers, setCurrentUsers] = useState([]);

  useEffect(() => {
    getEventData().then((data) => {
      console.log(data);
      setCapabilitiesData(data.capabilitiesData);
      setProjectType(data.projectType);
      setRegistrationFeilds(data.registrationFeilds);
      setDepartmentsData(data.departments);
      setRegionsData(data.regions);
    });

    getMetaData().then((data) => {
      const stats = {};
      // Object.keys(data.grades).map(gradeName => {
      //     stats[gradeName] = {};
      // });
      // setStats(stats);
      setGrades(_.orderBy(data.grades, ["order"], ["asc"]));
      // setCapabilitiesData(data.capabilities);
      if (data.grades) {
        setGradesData(data?.grades.map((_grade) => _grade.name));
      }
    });
  }, []);

  useEffect(async () => {
    if (capability) {
      getAnalytics().then((data) => {
        setActiveUserCount(data);
      });
    }
    if (currentUsers.length == 0 && users.length == 0 && capability) {
     
      await getUsersData(capability).then((data) => {
        setStats(data._stats);
        setUsers(data._users);
        setShowingData(data._users);
        setCurrentUsers((prevUsers) => [...prevUsers, ...data._users]);
       
      });
    } else if (
      currentUsers.length < rowsPerPage * currentPage - rowsPerPage + 1 &&
      capability
    ) {
      await getUsersData(capability).then((data) => {
        setStats(data._stats);
        setUsers(data._users);
        setShowingData(data._users);
        setCurrentUsers((prevUsers) => [...prevUsers, ...data._users]);
      });
    } else if (currentUsers.length != 0) {
      setUsers(
        currentUsers.slice(
          currentPage * rowsPerPage - rowsPerPage,
          currentPage * rowsPerPage
        )
      );

      setShowingData(
        currentUsers.slice(
          currentPage * rowsPerPage - rowsPerPage,
          currentPage * rowsPerPage
        )
      );
    }
  }, [currentPage, rowsPerPage, capability]);

  useEffect(() => {
    if (users.length > 0 && capability) {
      let data = [];
      data = showingData
        .map((user) => {

          console.log(user,"user in map")
          if (capability) {
            const _cap = capability;
              const averagePercentage = user[_cap]?.averagePercentage ?? 0;
            user.capability = {
              name: capability,
                value: numeral(averagePercentage).format("0,0"),
            };

            let category = "";
            for (const _grade of grades) {
              if (
                _grade?.start - 1 < user?.capability.value &&
                _grade?.end + 1 > user?.capability.value
              ) {
                category = _.startCase(_grade?.name);
                break;
              }
            }

            user.category = category;
          }

          return user;
        })
        .filter((user) => {
          let result = true;

          if (capability) {
            result = result && user.capability.name === capability;
          }
          // if (categories.length > 0) {
          //     result = result && categories.includes(user.category);
          // }
          if (departments.length > 0) {
            result = result && departments.includes(user.department);
          }
          if (regions.length > 0) {
            result =
              result &&
              regions
                .map((e) => e.toLowerCase())
                .includes(user.region.toLowerCase());
          }

          return result;
        });

      setTableData(data);
    } else {
      setTableData([]);
    }
  }, [capability, categories, departments, regions, showingData, showing]);

  // useEffect(() => {
  //   if (users.length > 0) {
  //     if (showing === "completed") {
  //       const _data = users.filter((user) => user.completedOnce);
  //       setShowingData(_data);
  //     } else {
  //       setShowingData(users);
  //     }
  //   }
  // }, [showing]);

  // stats -> capability1 -> [{user: dicota@geniteam.pk, percentage: 200, levels: 2}]
  const getAnalytics = async () => {
    const Capability = `capabilities.${capability}`;
    let q;
    if (showing == "all") {
      q = query(
        usersRef,
        where("eventId", "==", eventId),
        where(Capability, "!=", null) // Checks if the specific capability exists in capabilities
      );
    } else {
      q = query(
        usersRef,
        where("eventId", "==", eventId),
        where(Capability, "!=", null), // Checks if the specific capability exists in capabilities
        where("completedOnce", "==", true)
      );
    }
    const snapshot = await getCountFromServer(q);
    let count = snapshot.data().count;
    return count;
  };
  const getUsersData = async (capability, useLastVisible = true) => {
    console.log(capability, "capability in get");
    const Capability = `capabilities.${capability}`;
    const _stats = {},
      _users = [];
    let q;

    if (useLastVisible && lastVisible) {
      if (showing === "completed") {
        q = query(
          usersRef,
          where("eventId", "==", eventId),
          where("completedOnce", "==", true),
          where(Capability, "!=", null), 
          startAfter(lastVisible),
          limit(10)
        );
      } else {
        q = query(
          usersRef,
          where("eventId", "==", eventId),
          where(Capability, "!=", null), 
          startAfter(lastVisible),
          limit(10)
        );
      }
    } else {
      if (showing === "completed") {
        q = query(
          usersRef,
          where("eventId", "==", eventId),
          where("completedOnce", "==", true),
          where(Capability, "!=", null), 
          limit(10)
        );
      } else {
        q = query(
          usersRef,
          where("eventId", "==", eventId),
          where(Capability, "!=", null), 
          limit(10)
        );
      }
    }
   
    const querySnapshot = await getDocs(q);
    setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
    querySnapshot.docs.forEach((doc) => {
      if (doc.id !== "analytics") {
        const userData = doc.data();

        const user = { id: doc.id };
        // _users.push({id: doc.id, ...userData});
        if (userData.capabilities) {
          Object.keys(userData.capabilities).map((capabilityName) => {
            const capability = userData.capabilities[capabilityName];
            const userObject = {
              user: doc.id,
              percentage: 0,
              levels: 0,
              achievedScore: 0,
              totalScore: 0,
            };

            // if (capability.status && capability.scores) {
            if (capability.scores) {
              if (!_stats[capabilityName]) {
                _stats[capabilityName] = [];
              }

                const percentages = [];

              Object.keys(capability.scores).map((levelName) => {
                  const scores = capability.scores[levelName];

                  // Prevent to show mini-games data in levels (same as UserStrengths.jsx and StrengthDetails.jsx)
                  const fieldNames = ['level2', 'level4', 'level6', 'level8', 'level10'];
                  if (!fieldNames.includes(levelName)) {
                      if (scores.totalQuestions > 0) {
                          userObject.percentage += scores.percentage;
                          userObject.achievedScore += scores.achievedScore;
                          userObject.totalScore += scores.totalScore;
                          userObject.levels++;
                      }

                      // Calculate percentage for each level (only include levels where totalScore > 0)
                      if (scores.totalScore > 0) {
                          const percentage = Math.round((scores.achievedScore / scores.totalScore) * 100);
                          percentages.push(percentage);
                      }
                }
              });

                // Calculate average of all collected percentages and round the result
                if (percentages.length > 0) {
                    const sum = percentages.reduce((acc, val) => acc + val, 0);
                    userObject.averagePercentage = Math.round(sum / percentages.length);
                } else {
                    userObject.averagePercentage = 0;
                }
              
              // console.log(userObject);
              _stats[capabilityName].push(userObject);
              user[capabilityName] = userObject;
            } else {
                userObject.averagePercentage = 0;
                _stats[capabilityName].push(userObject);
                user[capabilityName] = userObject;
            }
          });
        }

        _users.push({
          id: doc.id,
          ...user,
          name: userData.name,
          email: userData.email,
          department: userData.department,
          region: userData.region,
          completedOnce: userData.completedOnce,
        });
      }
    });
    console.log(_stats);
    console.log(_users, "data from db");
    return { _stats: _stats, _users: _users };
  };

  const getMetaData = async () => {
    const docRef = doc(utilRef, "meta");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    }

    return {};
  };

  const getEventData = async () => {
    const docRef = doc(db, "Events", eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data().selectedLevels.competencies.map((e) => {
        return e.name;
      });
      return {
        capabilitiesData: data,
        projectType: docSnap.data().projectType,
        registrationFeilds: docSnap.data().registrationFields,
        departments: docSnap.data().departments,
        regions: docSnap.data().region,
      };
    }
  };
  const SetShow = () => {
    setCapability(null);
    setCurrentPage(1);
    setCurrentUsers([]);
    setUsers([]);
    setShowingData([]);
    setTableData([]);
    setLastVisible(null);
    setShowing("completed");
  };
  const SetShowAll = () => {
    setCapability(null);
    setCurrentPage(1);
    setCurrentUsers([]);
    setUsers([]);
    setShowingData([]);
    setTableData([]);
    setLastVisible(null);
    setShowing("all");
  };
  const checkProjectType = () => {
    return projectType === "progress";
  };
  return (
    <>
      <Container fluid>
        <Row>
          {grades.map((grade) => (
            <Col lg={3} md={6} className="mb-4">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <p className="text-muted small mb-0">Users</p>
                  <h2 className="mb-0">{_.startCase(grade.name)}</h2>
                </CardHeader>
                <CardBody>
                  {Object.keys(stats).map((capabilityName) => (
                    <div className="d-flex justify-content-between mb-0">
                      <p className="text-muted mb-0">
                        {_.startCase(capabilityName)}
                      </p>
                      <p className="text-primary font-weight-bold mb-0">
                        {stats[capabilityName].filter((user) => {
                            const percentage = user.averagePercentage ?? 0;
                          return (
                            grade.start - 1 < percentage &&
                            grade.end + 1 > percentage
                          );
                        }).length || "-"}
                      </p>
                    </div>
                  ))}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h1 className="mb-0 custom-font letterSpacing">Filters</h1>
              <div className="d-flex justify-content-start">
                <label
                  htmlFor="site_state"
                  className={classNames("fw-bold", {
                    "text-muted": showing !== "all",
                  })}
                >
                  All Users
                  {/*<span className="badge bg-primary small ms-2">discounted</span>*/}
                </label>
                <label className="switch mx-2">
                  <input
                    id="site_state"
                    type="checkbox"
                    onChange={({ target }) => {
                      target.checked ? SetShow() : SetShowAll();
                    }}
                  />
                  <span className="switch-slider always-on round" />
                </label>
                {/*<div className="form-check form-switch" style={{paddingLeft: 0}}>*/}
                {/*    <input type="checkbox" className="form-check-input always-on-switch" id="site_state"*/}
                {/*           onChange={({target}) => {*/}
                {/*               target.checked ? setShowing('all') : setShowing('completed')*/}
                {/*           }}*/}
                {/*    />*/}
                {/*</div>*/}
                <label
                  htmlFor="site_state"
                  className={classNames("fw-bold", {
                    "text-muted": showing !== "completed",
                  })}
                >
                  Only Completed
                </label>
              </div>
            </div>

            <Row>
              <Col>
                <Row className="filters-bg d-flex mb-4 ">
                  <Col>
                    <Multiselect
                      className="form-control-alternative mb-1 filters-sub"
                      isObject={false}
                      showArrow={true}
                      selectionLimit={1}
                      placeholder="Competency"
                      options={capabilitiesData.map((data) =>
                        _.startCase(data)
                      )}
                      closeIcon="cancel"
                      onSelect={(list, item) =>
                        setCapability(
                          capabilitiesData.find(
                            (_cap) => item === _.startCase(_cap)
                          )
                        )
                      }
                      onRemove={(list, item) => {
                        setCapability(null);
                        setCurrentPage(1);
                        setCurrentUsers([]);
                        setUsers([]);
                        setShowingData([]);
                        setTableData([]);
                        setLastVisible(null);
                      }}
                      style={multiselectDropdownStyle}
                    />
                    <div className="d-flex justify-content-between align-items-center ">
                      <p className="mb-0 small text-muted">Required</p>
                      <p className="mb-0 small text-muted">Single Select</p>
                    </div>
                  </Col>
                  {/* <Col lg={3}>
                                        <Multiselect
                                            className="form-control-alternative mb-1"
                                            isObject={false}
                                            showArrow={true}
                                            placeholder="Category"
                                            options={gradesData.map(data => _.startCase(data))}
                                            closeIcon="cancel"
                                            onSelect={(list, item) => setCategories([...categories, item])}
                                            onRemove={(list, item) => setCategories(categories.filter(i => i !== item))}
                                            style={multiselectDropdownStyle}
                                        />
                                        <p className="mb-0 small text-muted float-right">Multi Select</p>
                                    </Col> */}
                  {checkProjectType() &&
                    registrationFeilds.includes("department") && (
                      <Col>
                        <Multiselect
                          className="form-control-alternative mb-1 filters-sub"
                          isObject={false}
                          showArrow={true}
                          placeholder="Department"
                          options={departmentsData}
                          closeIcon="cancel"
                          onSelect={(list, item) =>
                            setDepartments([...departments, item])
                          }
                          onRemove={(list, item) =>
                            setDepartments(
                              departments.filter((i) => i !== item)
                            )
                          }
                          style={multiselectDropdownStyle}
                        />
                        <p className="mb-0 small text-muted float-right">
                          Multi Select
                        </p>
                      </Col>
                    )}
                  {checkProjectType() &&
                    registrationFeilds.includes("region") && (
                      <Col>
                        <Multiselect
                          className="form-control-alternative mb-1 filters-sub"
                          isObject={false}
                          showArrow={true}
                          placeholder="Region"
                          options={regionsData}
                          closeIcon="cancel"
                          onSelect={(list, item) =>
                            setRegions([...regions, item])
                          }
                          onRemove={(list, item) =>
                            setRegions(regions.filter((i) => i !== item))
                          }
                          style={multiselectDropdownStyle}
                        />
                        <p className="mb-0 small text-muted float-right">
                          Multi Select
                        </p>
                      </Col>
                    )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <Card className="shadow">
              {/*<CardHeader className="border-0">*/}
              {/*    <h2 className="mb-0">Leaderboard</h2>*/}
              {/*</CardHeader>*/}
              <DataTable
                columns={[
                  {
                    name: "Name",
                    wrap: true,
                    minWidth: "20%",
                    selector: (row) => row.name,
                  },
                  {
                    name: "Email",
                    wrap: true,
                    minWidth: "25%",
                    selector: (row) => row.email,
                  },
                  {
                    name: "Competency",
                    wrap: true,
                    minWidth: "20%",
                    cell: (row) =>
                      `${row.capability.name} - ${row.capability.value}%`,
                  },
                  // { name: 'Category', wrap: true, selector: row => row.category },
                  registrationFeilds.includes("department") && {
                    name: "Department",
                    wrap: true,
                    selector: (row) => row.department,
                  },
                  registrationFeilds.includes("region") && {
                    name: "Region",
                    wrap: true,
                    selector: (row) => row.region,
                  },
                ]}
                data={tableData}
                pagination
                paginationTotalRows={activeUserCount}
                paginationServer={true}
                responsive
                persistTableHead
                highlightOnHover
                paginationRowsPerPageOptions={[10]}
                onChangePage={(page, totalRows) => {
                  setCurrentPage(page);
                }}
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                  setRowsPerPage(currentRowsPerPage);
                }}
                currentPage={currentPage}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
